import * as React from "react";
import {
  Box,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionProps,
  BoxProps,
  useTheme,
} from "@mui/material";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

export interface MetadataBoxAccordionProps extends BoxProps {
  title: string;
  icon: React.ReactElement;
  rightContent?: React.ReactNode;
  accordionProps?: AccordionProps;
  defaultExpanded?: boolean;
}

const MetadataBoxAccordion: React.FC<MetadataBoxAccordionProps> = (props) => {
  const { title, icon, rightContent, children, defaultExpanded = true, accordionProps, ...otherProps } = props;
  const theme = useTheme();

  const containerStyle = {
    backgroundColor: "transparent",
    ":hover": {
      backgroundColor: theme.palette.backgroundAlpha.hover,
    },
  };

  return (
    <Box component="section" mb={2} {...otherProps}>
      <Accordion
        defaultExpanded={defaultExpanded}
        sx={{
          border: `1px solid ${theme.palette.backgroundAlpha.border}`,
          background: theme.palette.background.paper,
        }}
        {...accordionProps}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreRoundedIcon />}
          aria-controls="panel1a-content"
          style={containerStyle}
          id="panel1a-header"
          sx={{ ".MuiAccordionSummary-content": { justifyContent: "space-between", mr: 1 } }}
        >
          <Stack direction="row" alignItems="center" spacing={1.5}>
            {icon}
            <Typography variant="subtitle2" component="h3" fontWeight={600}>
              {title}
            </Typography>
          </Stack>
          {rightContent}
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 3, pb: 3 }}>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default MetadataBoxAccordion;
